function VehicleSelectorTracker(analytics) {
	'use strict';

	this.analytics = analytics;
}

VehicleSelectorTracker.prototype = {
	init: function () {
		'use strict';

        this.$selector = $('#dimensions-vehicle');
        this.$selector.find('select').each(this.bindHandler.bind(this));
    },

    /**
     * @param {Node} step
     */
    bindHandler: function (index, step) {
        'use strict';

        step.addEventListener('click', this.trackStep.bind(this));
    },

  	/**
     * @param {Event} event
     */
    trackStep: function (event) {
        'use strict';

        var step = event.target;

        this.analytics.track(
            'Vehicle Selector',
            'Select ' + step.id.replace('Id', ''),
            step.selectedOptions[0].text
        );
    }
};

export default VehicleSelectorTracker;